<template>
    <ModalPopup class="account-modal" :modelValue="modelValue" @update:modelValue="updateModelValue">
        <WebpImage
            class="account-modal__logo"
            src="/frontend/kasa-loyalty/img/static/logo.svg"
            alt="Sazka logo"
            width="82"
            height="82"
        />

        <div class="account-modal__content">
            <slot></slot>
            <div v-if="showConfirmButton || showCloseModalButton" class="account-modal__buttons">
                <button
                    v-show="showConfirmButton"
                    class="btn"
                    :class="confirmButtonTypeClass"
                    @click="confirmButtonClicked()"
                >
                    <KasaIcon v-if="confirmButtonIcon" :name="confirmButtonIcon" :width="20" :height="20" />{{
                        confirmButtonTitle
                    }}
                </button>
                <button
                    v-show="showCloseModalButton"
                    class="btn"
                    :class="closeButtonTypeClass"
                    @click="updateModelValue(false)"
                >
                    Zavřít
                </button>
            </div>
        </div>
    </ModalPopup>
</template>

<script setup lang="ts">
import { computed } from "vue";
import ModalPopup from "@/shared/components/modal-popup.vue";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import KasaIcon from "@/components/shared/assets/kasa-icon.vue";
import { BasicIcons } from "@/components/shared/assets/basic-icons";
import { AccountModalType } from "@/account/models/account-modal-type";

const emit = defineEmits(["update:modelValue", "confirmButtonClicked"]);

const props = withDefaults(
    defineProps<{
        modelValue: boolean;
        modalType?: AccountModalType;
        confirmButtonTitle?: string;
        confirmButtonIcon?: BasicIcons;
        confirmButtonTypeClass?: string;
        closeButtonTypeClass?: string;
    }>(),
    {
        modalType: AccountModalType.Basic,
        confirmButtonTitle: "Potvrdit",
        confirmButtonTypeClass: "btn-secondary",
        closeButtonTypeClass: "btn-blue",
    }
);

const updateModelValue = (value: boolean) => emit("update:modelValue", value);

const showConfirmButton = computed(() => props.modalType == AccountModalType.Confirmation);
const showCloseModalButton = computed(
    () => props.modalType == AccountModalType.Confirmation || props.modalType == AccountModalType.Information
);

const confirmButtonClicked = () => emit("confirmButtonClicked");
</script>
